module.exports = __webpack_public_path__ + "05_short_brown.32efcccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/05_short_brown.png
// module id = sc/g
// module chunks = 0